// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatGetBody = {
  chatId: string;
};

export type typeChatGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    chatId: string;
    chatType: "pool" | "private" | "standalone";
    title: string;
    photoMediaId?: string | null;
    poolId?: string | null;
    postPolicy: "everyone" | "officersOnly";
    isEnabled: boolean;
    memberCount: number;
    pinnedCount: number;
    mediaCount: number;
    myRole: "commissioner" | "admin" | "member";
    canPost: boolean;
    canModerate: boolean;
    muteState: "off" | "timed" | "indefinite";
    mutedUntil?: string | null;
    refreshAfterSeconds: number;
    avatarUrl?: string | null;
    timedOutUntilIso?: string | null;
    timedOutReason?: string | null;
    isChatSuspended?: boolean;
  };
};

export type typeChatGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatGetBody = {
  type: "object",
  properties: { chatId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatGetBody);
  }

  return async function postChatGet(
    payload: typeChatGetBody,
  ): Promise<typeChatGetOutput200 | typeChatGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatGet" failed before calling the network. #093c7e9b0169`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#093c7e9b0169" },
        },
        data: null,
      } as typeChatGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/get`,
      httpMethod: "POST",
      options,
    })) as typeChatGetOutput200 | typeChatGetOutput400;
  };
}
